// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components
const LeadSearch = () => import('@/modules/leads/views/LeadSearch')

var routes = [
    {
        path: '/',
        redirect: 'leads/search',
        component: DefaultContainer,
        children: [
            {
                path: 'leads/search',
                name: 'LeadSearch',
                component: LeadSearch,
				query: {
                    page: 1,
                    query: null
                },
            },
        ]
    }
];

export default routes;
